var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headercontent"},[_c('header',[_c('i',{staticClass:"iconfont icon-home_location_icon_l",on:{"click":_vm.closeHandsel}}),_c('p',[_vm._v(_vm._s(_vm.headerMsg.title ? _vm.headerMsg.title : _vm.$route.meta.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }